import { RowProductListType } from '@/src/types/product';
import React, { useRef } from 'react';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import CardProduct from './CardProduct';
interface ProductListV1Props {
    data: RowProductListType[];
}

const ProductListV1: React.FC<ProductListV1Props> = ({ data }) => {
    // Ref برای کنترل Swiper instance
    const swiperRef = useRef<any>(null);

    // توقف autoplay روی interaction
    const handleInteraction = () => {
        if (swiperRef.current && swiperRef.current.autoplay) {
            swiperRef.current.autoplay.stop();
        }
    };

    return (
        <div className="container mx-auto py-4">
            <Swiper
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                spaceBetween={20}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false, // چون خودمون هندل می‌کنیم
                }}
                loop={true}
                navigation
                modules={[Autoplay, Navigation]}
                breakpoints={{
                    870: {
                        slidesPerView: 2,
                    },
                    960: {
                        slidesPerView: 4,
                    },
                    1600: {
                        slidesPerView: 5,
                    },
                }}
                className="mySwiper"
                // با هر Interaction روی اسلایدر، autoplay رو متوقف می‌کنیم
                onClick={handleInteraction}
                onTouchStart={handleInteraction}
                onSlideChangeTransitionStart={handleInteraction}
            >
                {data?.map((item) => (
                    <SwiperSlide key={item.id}>
                        <CardProduct data={item} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default ProductListV1;
